import React, { useState, useEffect } from 'react';
import axios from 'axios';
import {toast } from "react-toastify";



function EditHearingForm({ hearingId, closeModal, onHearingUpdated }) {
  const [formData, setFormData] = useState({
    caseId: '',
    date: '',
    reminder: false,
    notes: ''
  });
  const [cases, setCases] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchCases = async () => {
      try {
        const token = localStorage.getItem("token");
        const res = await axios.get(`${process.env.REACT_APP_BACKEND_URL}/api/projects`,{
          headers: {
            Authorization: `Bearer ${token}`,
          },
          withCredentials: true,
        });
        setCases(res.data);
      } catch (error) {
        console.error('Error fetching cases:', error);
      }
    };

    const fetchHearing = async () => {
      try {
        const token = localStorage.getItem("token");
        const res = await axios.get(
          `${process.env.REACT_APP_BACKEND_URL}/api/hearings/${hearingId}`,
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
            withCredentials: true,
          }
        );
        setFormData({
          caseId: res.data.caseId || '',
          date: res.data.date ? res.data.date.slice(0, 10) : '',
          reminder: res.data.reminder || false,
          notes: res.data.notes || ''
        });
      } catch (err) {
        console.error("Error fetching hearing data:", err);
      }
    };

    Promise.all([fetchCases(), fetchHearing()]).then(() => setLoading(false));
  }, [hearingId]);

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: type === 'checkbox' ? checked : value,
    }));
  };

  const handleUpdate = async (e) => {
    e.preventDefault();
    const token = localStorage.getItem("token");
    if (!formData.caseId) {
      toast.warn("Please select a project.");
      return;
    }
    try {
      await axios.put(`${process.env.REACT_APP_BACKEND_URL}/api/hearings/${hearingId}`, formData,{
        headers: {
          Authorization: `Bearer ${token}`,
        },
        withCredentials: true,
      });
      toast.success("Hearing updated successfully!");
      onHearingUpdated();
      closeModal();
    } catch (error) {
      console.error("Error updating hearing:", error);
      toast.error("Failed to update hearing.");
    }
  };

  // Removed duplicate handleChange and handleUpdate declarations after refactor

  if (loading) return <div>Loading...</div>;

  return (
    <form onSubmit={handleUpdate} className="bg-white p-6 rounded-lg shadow-md space-y-4">
      <div>
        <label className="block mb-1 font-medium">Project</label>
        <select
          name="caseId"
          value={formData.caseId}
          onChange={handleChange}
          required
          className="w-full border border-gray-300 rounded px-3 py-2"
          placeholder="Select Project"
        >
          <option value="">Select Project</option>
          {cases.map((caseItem) => (
            <option key={caseItem._id} value={caseItem._id}>
              {caseItem.caseTitle}
            </option>
          ))}
        </select>
      </div>

      <div>
        <label className="block mb-1 font-medium">Hearing Date</label>
        <input
          type="date"
          name="date"
          value={formData.date}
          onChange={handleChange}
          required
          className="w-full border border-gray-300 rounded px-3 py-2"
          placeholder="Select hearing date"
        />
      </div>

      <div className="flex items-center gap-2">
        <input
          type="checkbox"
          name="reminder"
          checked={formData.reminder}
          onChange={handleChange}
          className="mr-2"
        />
        <label className="font-medium">Set Reminder</label>
      </div>

      <div>
        <label className="block mb-1 font-medium">Notes</label>
        <textarea
          name="notes"
          value={formData.notes}
          onChange={handleChange}
          className="w-full border border-gray-300 rounded px-3 py-2"
          placeholder="Enter notes about the hearing"
        />
      </div>

      <div className="flex gap-2">
        <button type="submit" className="bg-blue-600 text-white px-4 py-2 rounded hover:bg-blue-700">
          Update Hearing
        </button>
        <button type="button" onClick={closeModal} className="bg-gray-300 px-4 py-2 rounded">
          Cancel
        </button>
      </div>
    </form>
  );
}

export default EditHearingForm;
